import React from 'react';
import Icon from '../Icon';

const Benefit = ({ text }) => (
  <div className="benefit-item">
    <span className="check"><Icon name="check-bold" size={12} /></span>
    {text}
  </div>
);

const FinalCTA = ({ onCTA }) => (
  <section className="final-cta">
    <div className="container">
      <div className="final-cta-grid">
        <div>
          <span className="eyebrow eyebrow-dark">Last step</span>
          <h2 style={{ marginTop: 18 }}>
            Don't leave money on the table while caring for someone <em>you love.</em>
          </h2>
          <p className="lead" style={{ marginTop: 18, fontSize: 18 }}>
            It takes less than 2 minutes to find out if you qualify. We'll handle the rest.
          </p>
          <div className="hero-actions" style={{ marginTop: 28 }}>
            <button className="btn btn-primary btn-lg" onClick={onCTA}>
            Check Your Eligibility
              <Icon name="arrow-right" size={18} stroke={2.4} className="arrow" />
            </button>
          </div>
          <div className="cta-meta">
            <span className="cta-meta-item"><Icon name="lock" size={14} stroke={2.2} /> No SSN required to check</span>
            <span className="cta-meta-item"><Icon name="shield" size={14} stroke={2.2} /> HIPAA-compliant</span>
          </div>
        </div>

        <aside className="benefits-card">
          <h4>What you get</h4>
          <Benefit text="A personalized eligibility report — free" />
          <Benefit text="An estimate of your monthly payment" />
          <Benefit text="A dedicated advocate (not a chatbot)" />
          <Benefit text="All paperwork prepared for you" />
          <Benefit text="No fee until you're approved" />
        </aside>
      </div>
    </div>
  </section>
);

export default FinalCTA;
